export interface ModalAttrs {
  closeable: boolean;
  'grow-to-content': boolean;
  'hide-close-button': boolean;
  'modal-type': string;
  'modal-title': string;
  'modal-description': string;
  'not-fullscreen': boolean;
  open: boolean;
}

export interface ModalState {
  visibility: string;
}

export enum ExportDashboardModalPage {
  Main = `main`,
  ConfirmExternalUsers = `confirm-external-users`,
}
